<template>
  <v-dialog
    :value="showModal"
    @input="$store.commit('jobs/toggleModal', $event)"
    fullscreen
    transition="fade-transition"
    light
  >
    <v-card class="d-flex flex-column">
      <v-card flat dark color="primary" class="d-flex align-center pa-3">
        <div class="text-h5 font-weight-bold">
          Update job
        </div>
        <v-spacer></v-spacer>
        <v-btn
          @click="save"
          :loading="loading"
          class="mr-4"
        >
          Save
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
        <v-btn icon @click="$store.commit('jobs/closeModal')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>

      <v-container fluid>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="selected.position"
              label="Position"
              outlined
              dense
              hide-details
              class="mb-2"
            ></v-text-field>
            <v-select
              v-model="selected.status"
              :items="statuses"
              item-text="name"
              item-value="value"
              label="Status"
              outlined
              hide-details
              dense
              class="mb-2"
            ></v-select>
            <v-text-field
              v-model="selected.contact"
              label="Contact"
              outlined
              dense
              hide-details
              class="mb-2"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-textarea
              v-model="selected.comments"
              label="Comments"
              outlined
              dense
              hide-details
              no-resize
              class="mb-2"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-textarea
          v-model="selected.description"
          label="Description"
          outlined
          dense
          hide-details
          no-resize
          class="mb-2"
        ></v-textarea>
        <v-textarea
          v-model="selected.requirements"
          label="Requirements"
          outlined
          dense
          hide-details
          no-resize
          class="mb-2"
        ></v-textarea>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      statuses: [
          {
            name: 'Searching for developer', 
            value: 'searching'
          },
          {
            name: 'Waiting for offers response',
            value: 'waiting_offers_response'
          },
          {
            name: 'Preparing to interview',
            value: 'preparing_to_interview'
          },
          {
            name: 'Waiting for interview response',
            value: 'waiting_interview_response'
          },
          {
            name: 'Success',
            value: 'success'
          },
          {
            name: 'Holding',
            value: 'holding'
          },
          {
            name: 'Closed',
            value: 'closed'
          }],
    }
  },
  methods: {
    save() {
      this.loading = true;
      this.$store.dispatch('jobs/save').finally(() => {
        this.loading = false;
      })
    },
  },
  computed: {
    ...mapGetters({
      showModal: 'jobs/showModal',
      selected: 'jobs/selected',
    }),
  }
}
</script>

<style lang="scss" scoped>

</style>